import { useEffect } from "react";
import { PRODUCTS } from "../data/products";
import { useLang } from "../i18n";
import { MaskedLine, Reveal } from "../components/Reveal";
import { ProductCard } from "../components/ProductCard";
import { CatalogueButton } from "../components/CatalogueButton";

export default function Products() {
  const { t } = useLang();

  useEffect(() => {
    document.title = "Products | Scaffolding, Formwork, Cuplock — Sana Steel Industries";
  }, []);

  return (
    <main data-testid="products-page" className="pt-20">
      <section className="bg-navy py-24 md:py-32" data-testid="products-hero">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
          <MaskedLine delay={0.1}>
            <span className="section-eyebrow-dark inline-flex items-center gap-3">
              <span className="w-8 h-[2px] bg-silver inline-block" />
              {t("products.eyebrow")}
            </span>
          </MaskedLine>
          <h1 className="mt-6 font-heading font-black uppercase tracking-tighter text-white leading-[0.95] text-5xl md:text-7xl">
            <MaskedLine delay={0.25}>{t("products.l1")}</MaskedLine>
            <MaskedLine delay={0.4}>
              <span className="text-silver">{t("products.l2")}</span>
            </MaskedLine>
          </h1>
          <MaskedLine delay={0.55}>
            <p className="mt-8 max-w-xl text-white/70 text-base md:text-lg leading-relaxed">
              {t("products.sub")}
            </p>
          </MaskedLine>
          <div className="mt-8">
            <CatalogueButton variant="light" testId="products-download-catalogue" />
          </div>
        </div>
      </section>

      <section className="py-24 md:py-32 bg-white" data-testid="products-grid-section">
        <div className="max-w-7xl mx-auto px-5 md:px-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {PRODUCTS.map((p, i) => (
            <Reveal key={p.slug} delay={(i % 3) * 0.07}>
              <ProductCard product={p} index={i} />
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
}
